import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => ({
  data: {
    type: 'paragraph--text_headline',
    id: createTemporaryEntityId(),
    attributes: {
      langcode: getEntityTemplateLang(),
      status: true,
      default_langcode: true,
      field_hide_title: false,
      field_search_text: null,
      field_num_columns: 1,
      field_text: {
        value:
          'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna.',
        format: null,
      },
      field_title: { value: 'I am a Text Headline Module', format: 'rich_text' },
    },
    relationships: {
      field_assets: {
        data: [],
      },
      field_tags: {
        data: [],
      },
    },
    links: {},
    log: [],
    permissions: {
      update: true,
      create: true,
      delete: true,
    },
  },
  included: [],
});
